import { createBrowserHistory } from 'history';

export const history= createBrowserHistory({});


// WEBPACK FOOTER //
// ./web/history/history.jsx